(() => {
  if (window.__spoilsMaterialsUpdater) return;
  window.__spoilsMaterialsUpdater = true;

  const DEBUG = !!window.__spoilsDebug;
  const log = (...args) => DEBUG && console.log("[Spoils]", ...args);

  const $ = (sel, root = document) => root.querySelector(sel);

  function getVariantId() {
    const idInput = $('form[action*="/cart/add"] input[name="id"]');
    if (idInput?.value) return String(idInput.value);
    return new URL(location.href).searchParams.get("variant");
  }

  function getMaterialsSectionId() {
    const materials = $("[data-materials]");
    if (!materials) return null;
    const wrapper = materials.closest('[id^="shopify-section-"]');
    if (!wrapper) return null;
    return wrapper.id.replace("shopify-section-", "");
  }

  async function refreshMaterials(variantId) {
    const materials = $("[data-materials]");
    if (!materials || !variantId) return;

    const sectionId = getMaterialsSectionId();
    if (!sectionId) return log("No sectionId");

    const url = `${location.pathname}?variant=${encodeURIComponent(variantId)}&sections=${encodeURIComponent(sectionId)}`;

    try {
      log("Fetching", url);
      const res = await fetch(url, { credentials: "same-origin" });
      const json = await res.json();
      const html = json?.[sectionId];
      if (!html) return log("No HTML returned for section", sectionId);

      const doc = new DOMParser().parseFromString(html, "text/html");
      const next = doc.querySelector("[data-materials]");
      if (!next) return log("No [data-materials] in fetched HTML");

      materials.innerHTML = next.innerHTML;
      log("Materials updated → variant", variantId);
    } catch (e) {
      console.warn("[Spoils] Materials refresh failed", e);
    }
  }

  let lastVariant = null;
  let t = null;

  function schedule() {
    // delay slightly so Prestige updates the hidden variant input first
    clearTimeout(t);
    t = setTimeout(() => {
      const v = getVariantId();
      if (!v || v === lastVariant) return;
      lastVariant = v;
      refreshMaterials(v);
    }, 60);
  }

  function boot() {
    lastVariant = getVariantId();
    log("Boot, initial variant:", lastVariant);

    document.addEventListener("variant:change", schedule);

    document.addEventListener(
      "change",
      (e) => {
        if (e.target.closest("variant-picker, form[action*='/cart/add']")) schedule();
      },
      true
    );

    document.addEventListener(
      "click",
      (e) => {
        if (e.target.closest("variant-picker")) schedule();
      },
      true
    );

    // Catch Prestige partial rerenders that might replace nodes
    const root = $("product-rerender") || document.body;
    const mo = new MutationObserver(() => schedule());
    mo.observe(root, { subtree: true, childList: true });

    schedule();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
